import ContentManagmentApi from '../../../services/api/contentManagmentApi.js'

const ContentManagmentApiService = new ContentManagmentApi()

export default {
  data() {
    return {
      featured: []
    }
  },

  methods: {
    getLandingCollection
    // redirect,
  },
  beforeMount() {
    this.getLandingCollection()
  },
  computed: {
    getTarget() {
      return function (url) {
        // Check if the existing URL contains "bulletin.co"
        if (url?.includes('bulletin.co')) {
          return '_self' // No target attribute (opens in the same tab)
        } else {
          return '_blank' // Open in a new tab
        }
      }
    }
  }
}

// function redirect(url) {
//   this.$router.push(`/collection/${name}/${id}`);
// }

function getLandingCollection() {
  ContentManagmentApiService.getFeaturedCollections()
    .then((response) => {
      this.featured = response.data
    })
    .catch((error) => {
      this.$handleError(this, error)
    })
}
